import api from "@/services/api";

export type MyReferralLinkType = {
  code: string;
  url: string;
  source: "associate" | "franchise";
};

class GetMyReferralLink {
  execute = async (franchiseId?: string) => {
    const response = await api().get("/referral/my-link", {
      params: franchiseId ? { franchiseId } : undefined,
    });
    return response.data as MyReferralLinkType;
  };
}

export { GetMyReferralLink };
